import React, { useState } from 'react';
import { Row, Col, Label, Input, Button, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
import MemberMembershipService from '../../../../../../services/member_membership_service';
import ConfirmDialog from '../../../../../../components/Common/ConfirmDialog';
import { formatCurrency } from '../../../../../../utils/format';
import { toISODate, formatDate } from '../../../../../../utils/date';

const ActionCancel = ({ membership, idTenant, user, onRefresh }) => {
    const [isScheduledCancel, setIsScheduledCancel] = useState(false);
    const [cancelDate, setCancelDate] = useState("");
    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);

    const handleCancel = async () => {
        if (!reason.trim()) return toast.warning("Informe o motivo.");
        if (isScheduledCancel && !cancelDate) return toast.warning("Informe a data agendada para o cancelamento.");

        const effectiveDate = isScheduledCancel ? cancelDate : toISODate(new Date());

        const ok = await ConfirmDialog({
            title: isScheduledCancel ? "Agendar Cancelamento?" : "Cancelar plano?",
            text: isScheduledCancel 
                ? `O plano de "${membership.memberName}" será cancelado automaticamente em ${formatDate(effectiveDate)}.` 
                : `Cancelar "${membership.membershipName}" de "${membership.memberName}" agora? Esta ação não pode ser desfeita.`,
            confirmButtonText: "Sim, confirmar!",
            confirmButtonColor: "#dc3545"
        });
        if (!ok) return;

        setLoading(true);
        try {
            await MemberMembershipService.cancel(membership.id, idTenant, user, membership, reason, effectiveDate);
            toast.success(isScheduledCancel ? "Cancelamento agendado." : "Plano cancelado.");
            setCancelDate("");
            setIsScheduledCancel(false);
            setReason("");
            onRefresh?.();
        } catch { toast.error("Erro ao cancelar."); }
        finally { setLoading(false); }
    };

    return (
        <div className="p-4 border rounded-0 mt-3 bg-white">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                    <i className="mdi mdi-close-circle-outline fs-4 me-2 text-muted"></i>
                    <h6 className="fw-bold mb-0 text-dark text-uppercase" style={{ letterSpacing: "0.5px" }}>
                        Cancelar Plano
                    </h6>
                </div>
                <div className="form-check form-switch font-size-12">
                    <input className="form-check-input" type="checkbox" role="switch" id="switchSchedCancel"
                        checked={isScheduledCancel} onChange={(e) => setIsScheduledCancel(e.target.checked)} />
                    <label className="form-check-label text-muted ms-1" htmlFor="switchSchedCancel">Agendar futuro?</label>
                </div>
            </div>

            <p className="text-muted font-size-13 mb-4">
                O cancelamento interromperá os serviços deste aluno. Se não houver data agendada, o contrato é cancelado imediatamente.
            </p>

            {membership.cancellationFee > 0 && (
                <div className="d-flex align-items-center bg-light border p-2 rounded-0 mb-4">
                    <i className="mdi mdi-alert-outline fs-5 text-muted mx-2"></i>
                    <div className="flex-grow-1 font-size-12 text-muted">
                        Multa estipulada em contrato: <strong className="text-dark">{formatCurrency(membership.cancellationFee)}</strong>
                    </div>
                    {membership.cancellationNoticeDays > 0 && (
                        <div className="font-size-12 ms-3 pe-2 text-muted">
                            Aviso prévio necessário: <strong className="text-dark">{membership.cancellationNoticeDays} dias</strong>
                        </div>
                    )}
                </div>
            )}

            <Row className="g-3 align-items-start">
                <Col md={3}>
                    <Label className="font-size-12 fw-medium text-dark mb-1">Data Efetiva *</Label>
                    <Input 
                        type="date" 
                        bsSize="sm"
                        value={isScheduledCancel ? cancelDate : toISODate(new Date())} 
                        onChange={e => setCancelDate(e.target.value)} 
                        disabled={!isScheduledCancel}
                        className="py-2 bg-light border-0"
                    />
                </Col>
                <Col md={5}>
                    <Label className="font-size-12 fw-medium text-dark mb-1">Motivo do Cancelamento *</Label>
                    <Input 
                        type="text" 
                        bsSize="sm"
                        placeholder="Descreva a razão de saída..."
                        value={reason} 
                        onChange={e => setReason(e.target.value)} 
                        className="py-2 bg-light border-0"
                    />
                </Col>
                <Col md={4} className="d-flex align-items-end" style={{ height: "62px" }}>
                    <Button 
                        color="dark" 
                        className="w-100 fw-medium font-size-13 d-flex align-items-center justify-content-center rounded-0"
                        style={{ height: "36px" }}
                        onClick={handleCancel} 
                        disabled={loading || !reason.trim()}
                    >
                        {loading ? <Spinner size="sm" className="me-2" /> : null}
                        Confirmar
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default ActionCancel;
